module.exports = __webpack_public_path__ + "844eeb9e8fa1b27feb2dba2dbc2e2394.svg";